import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface Tab {
  name:string,
  href?:string
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less']
})
export class TabsComponent implements OnInit {
  
  @Input() tabs:Tab[]
  @Output() outputSelectedTab = new EventEmitter<Tab>()

  selected:Tab
  constructor() { }

  tabClicked(tab:Tab) {
    this.selected = tab;
    this.outputSelectedTab.emit(tab);
  }

  ngOnInit() {
    if (this.tabs.length === 0) {
      console.warn("No tabs provided in tabs component");
    }
    this.selected = this.tabs[0]
    this.outputSelectedTab.emit(this.selected);
  }
}
